class KlarnaMonthlyCalculator extends HTMLElement {
  constructor() {
    super();
    this.variantChangeUnsubscriber = undefined;
  }

  connectedCallback() {
    this.updateCalculation();
    this.subscribeToVariantChanges();
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  subscribeToVariantChanges() {
    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      (event) => {
        if (event.data.sectionId === this.dataset.sectionId) {
          this.updateCalculation(event.data.variant);
        }
      },
    );
  }

  updateCalculation(variant = null) {
    let messageEl = this.querySelector(".js-klarna-monthly-calculator__message");

    if (!variant || !messageEl) return;

    let price =
      variant?.price ||
      parseInt(
        this.messageEl?.textContent?.match(/\d+/) || this.dataset.price || 0,
        10,
      );

    const multiplier = parseFloat(this.dataset.multiplier);
    const minThreshold = parseInt(this.dataset.minPriceThreshold, 10);
    const messageTemplate =
      this.dataset.messageTemplate ||
      "Available from {monthly_price} per month.";

    if (price < minThreshold) {
      messageEl.classList.add("hidden");
      return;
    }

    messageEl.classList.remove("hidden");

    // Calculate monthly payment
    const monthlyPriceFloat = price * multiplier;
    const monthlyPricePence = Math.ceil(monthlyPriceFloat);

    // Format the message
    const formattedPrice = Shopify.formatMoney(
      monthlyPricePence,
      this.dataset.moneyFormat || "£{{ amount }}",
    );
    const message = messageTemplate.replace("{monthly_price}", formattedPrice);

    messageEl.textContent = message;
  }
}

if (!customElements.get("klarna-monthly-calculator")) {
  customElements.define("klarna-monthly-calculator", KlarnaMonthlyCalculator);
}
